module.exports = __webpack_public_path__ + "static/media/number4.287438ff.mp3";